/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Arrow } from 'icons/untitledui';

import * as Styled from 'topBar/styles/TopBarButtons.style';

interface TopBarBackButtonProps {
  onClick?: () => void;
  ariaLabel?: string;
  hideOnDesktop?: boolean;
  icon?: React.ReactNode;
}

export function TopBarBackButton({
  onClick,
  ariaLabel = 'Back',
  hideOnDesktop = false,
  icon,
}: TopBarBackButtonProps): JSX.Element {
  return (
    <Styled.BackButton
      onClick={onClick}
      aria-label={ariaLabel}
      $hideOnDesktop={hideOnDesktop}
    >
      {icon || <Arrow.ChevronLeft />}
    </Styled.BackButton>
  );
}
